import { type FormEvent, type ButtonHTMLAttributes } from 'react'
import * as S from './styles'
import { useResetFinancingForm } from 'containers/Financing/PerValue/CreateFinancingPerValueModal/hooks/useResetFinancingForm'

export const ClearFieldsButton = ({
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement>) => {
  const { resetFormValues } = useResetFinancingForm()

  const handleClearFields = (e: FormEvent) => {
    e.preventDefault()
    resetFormValues()
  }

  return (
    <S.Container type="button" onClick={handleClearFields} {...props}>
      Limpar dados
    </S.Container>
  )
}
